import script from "./CollectionImages.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionImages.vue?vue&type=script&setup=true&lang=js"

import "./CollectionImages.vue?vue&type=style&index=0&id=78f69720&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78f69720"]])

export default __exports__